import React, { useCallback, useMemo } from 'react'

import {
  IconButton,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
  Tooltip,
} from '@chakra-ui/react'
import { BarsArrowDownIcon } from '@heroicons/react/24/solid'
import { useDispatch, useSelector } from 'react-redux'

import { setCaseworkOrderBy } from '../../../redux/features/caseworkSlice'

const CaseworkSortMenu = () => {
  const dispatch = useDispatch()
  const orderBy =
    useSelector(state => state.casework.filters.order_by) || '-active_status'

  const handleOrderChange = useCallback(
    value => {
      const category = orderBy[0] === '-' ? orderBy.slice(1) : orderBy
      dispatch(setCaseworkOrderBy(value + category))
    },
    [orderBy, dispatch, setCaseworkOrderBy]
  )

  const handleCategoryChange = useCallback(
    value => {
      const updatedOrderBy = `${orderBy[0] === '-' ? '-' : ''}${value}`
      dispatch(setCaseworkOrderBy(updatedOrderBy))
    },
    [orderBy, dispatch, setCaseworkOrderBy]
  )

  const categoryValue = useMemo(
    () =>
      orderBy.length > 0 && orderBy[0] === '-' ? orderBy.slice(1) : orderBy,
    [orderBy]
  )

  const orderByValue = useMemo(
    () => (orderBy.length > 0 && orderBy[0] === '-' ? '-' : ''),
    [orderBy]
  )

  return (
    <Menu closeOnSelect={false}>
      <Tooltip label='Sorting options' placement='left'>
        <MenuButton
          as={IconButton}
          icon={<BarsArrowDownIcon />}
          p={1}
          variant='unstyled'
          aria-label='Sorting options for casework'
        />
      </Tooltip>
      <MenuList>
        <MenuOptionGroup
          defaultValue='-'
          title='Order'
          type='radio'
          value={orderByValue}
          onChange={value => handleOrderChange(value)}
        >
          <MenuItemOption value=''> Ascending </MenuItemOption>
          <MenuItemOption value='-'> Descending </MenuItemOption>
        </MenuOptionGroup>
        <MenuDivider />
        <MenuOptionGroup
          title='Category'
          defaultValue='opened_at'
          type='radio'
          value={categoryValue}
          onChange={value => handleCategoryChange(value)}
        >
          <MenuItemOption value='case_num'> Case number </MenuItemOption>
          <MenuItemOption value='active_status'>
            Active statuses first
          </MenuItemOption>
          <MenuItemOption value='status'> Status </MenuItemOption>
          <MenuItemOption value='priority'> Priority </MenuItemOption>
          <MenuItemOption value='opened_at'> Opened date </MenuItemOption>
          <MenuItemOption value='closed_at'> Closed date </MenuItemOption>
          <MenuItemOption value='last_updated'> Last updated </MenuItemOption>
          <MenuItemOption value='constituent__name'>
            Constituent Name
          </MenuItemOption>
        </MenuOptionGroup>
      </MenuList>
    </Menu>
  )
}

export default CaseworkSortMenu
